"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelOk = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelOk = function SvgChannelOk(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#sc_ok__paint0_linear)",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M60.5 32.798c4.578 0 8.301 3.738 8.301 8.335 0 4.592-3.725 8.33-8.302 8.33-4.575 0-8.3-3.738-8.3-8.33 0-4.597 3.726-8.335 8.3-8.335zm0 28.458c11.058 0 20.05-9.026 20.05-20.123C80.55 30.03 71.56 21 60.5 21c-11.058 0-20.052 9.03-20.052 20.133 0 11.097 8.994 20.123 20.051 20.123zm8.111 16.42a37.458 37.458 0 0011.643-4.84 5.897 5.897 0 002.6-3.682 5.917 5.917 0 00-2.33-6.122 5.861 5.861 0 00-4.385-1.004c-.76.13-1.489.41-2.141.823-8.215 5.184-18.788 5.18-26.996 0a5.855 5.855 0 00-8.1 1.853 5.917 5.917 0 00-.756 4.449 5.897 5.897 0 002.598 3.683 37.494 37.494 0 0011.64 4.84L41.177 88.931a5.91 5.91 0 00-1.72 4.171 5.91 5.91 0 001.721 4.17A5.863 5.863 0 0045.331 99a5.863 5.863 0 004.154-1.728l11.013-11.058 11.018 11.059A5.865 5.865 0 0075.667 99a5.846 5.846 0 004.151-1.728 5.888 5.888 0 001.724-4.17 5.908 5.908 0 00-1.724-4.169L68.612 77.676z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_ok__paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#FF9F2F"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#ED832B"
  }))));
};

exports.SvgChannelOk = SvgChannelOk;